var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 1.3335C1.63173 1.3335 1.33325 1.63197 1.33325 2.00016V6.66683C1.33325 7.03502 1.63173 7.3335 1.99992 7.3335H6.66659C7.03477 7.3335 7.33325 7.03502 7.33325 6.66683V2.00016C7.33325 1.63197 7.03477 1.3335 6.66659 1.3335H1.99992ZM2.66659 6.00016V2.66683H5.99992V6.00016H2.66659Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 1.3335C8.96506 1.3335 8.66659 1.63197 8.66659 2.00016V6.66683C8.66659 7.03502 8.96506 7.3335 9.33325 7.3335H13.9999C14.3681 7.3335 14.6666 7.03502 14.6666 6.66683V2.00016C14.6666 1.63197 14.3681 1.3335 13.9999 1.3335H9.33325ZM9.99992 6.00016V2.66683H13.3333V6.00016H9.99992Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66659 9.3335C8.66659 8.96531 8.96506 8.66683 9.33325 8.66683H13.9999C14.3681 8.66683 14.6666 8.96531 14.6666 9.3335V14.0002C14.6666 14.3684 14.3681 14.6668 13.9999 14.6668H9.33325C8.96506 14.6668 8.66659 14.3684 8.66659 14.0002V9.3335ZM9.99992 10.0002V13.3335H13.3333V10.0002H9.99992Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99992 8.66683C1.63173 8.66683 1.33325 8.96531 1.33325 9.3335V14.0002C1.33325 14.3684 1.63173 14.6668 1.99992 14.6668H6.66659C7.03477 14.6668 7.33325 14.3684 7.33325 14.0002V9.3335C7.33325 8.96531 7.03477 8.66683 6.66659 8.66683H1.99992ZM2.66659 13.3335V10.0002H5.99992V13.3335H2.66659Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.10574,
    y1: -3.53423,
    x2: 7.99992,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.10574,
    y1: -3.53423,
    x2: 7.99992,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 8.10574,
    y1: -3.53423,
    x2: 7.99992,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 8.10574,
    y1: -3.53423,
    x2: 7.99992,
    y2: 14.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F165B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF503C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.2f32018e.svg";
export { ForwardRef as ReactComponent };